export default __webpack_public_path__ + "static/media/no_project.6acf4090.svg";